import { Tooltip } from 'antd'
import AntdAvatar from 'components/Avatar'
import Pagination from 'components/Pagination'
import React, { useState } from 'react'
import { StyledTablecount } from '../../../components/TableStyles/TableStylesSqare/JobRolePreview'
import {
  EmptyDivElement,
  EmptySpanElement,
} from '../../../components/UIComponents/CommonStyledComponent'
import PlacementHistoryWithResume from '../../../components/UIComponents/PlacementHistoryWithResume'
import TableJobSearchFilter from '../../../components/UIComponents/TableJobSearchFilter'
import RestrictionsPanel from '../../../components/UIComponents/RestrictionsPanel'
import RightSideArrowIco from '../../../components/icons/RightSideArrowIco'
import DownSideArrowIco from '../../../components/icons/DownSideArrowIco'
import {
  FlexWrap,
  RowNumberData,
} from '../style'
import {
  ActionButton,
  BorderContainer,
  ContainerAlignment,
  FilterTotalCount,
  HeadingText,
} from '../style'
import { toCamelCase } from '../../../utils/helpers'
import ExportTransfer from '../../../components/ExportTransfer'
import ErrorMessage from '../../../utils/ErrorMessage'
import PILAccept from '../../../components/icons/PILAccept'
import PILReject from '../../../components/icons/PILReject'
import PILPending from '../../../components/icons/PILPending'

export default function JobCandidateList({
  getPreview,
  candidateList,
  onPageChange,
  state,
  objectRef,
  metricsData,
  setState,
  handleHeaderCellClick,
  handleSearch,
  getPlacementHistoryList,
  getStudentPlacedList,
  jobRolePreviewData,
  getJobRolePreview,
  isLoadingState,
  categorayFilter,
  exportCandidate,
  getExportFiledData,
  params,
  instituteCampusId,
  status,
  downlaodData,
  instituteDetails
}) {
  const [studentId, setStudentId] = useState(null)
  const [isOpenHistory, setIsOpenHistory] = useState(false)
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  
  const handleNameClick = async data => {
    setStudentId(data?.id)
    setIsOpenHistory(true)
  }
  const exportColumns = [
    {
      dataIndex: 'title',
      title: 'Name',
    },
  ]


  const [selectedKeys, setSelectedKeys] = useState([])
  const [targetKeys, setTargetKeys] = useState([])
  const [disabled, setDisabled] = useState(false)
  const [transfer, setTransfer] = useState(false)
  const [exportType, setExportType] = useState('')
  const [exportData, setData] = useState([])
    const handleExportType = value => {
      if (exportType == value) {
        setExportType('')
      } else {
        setExportType(value)
      }
  }
    const [exportLoading, setExportLoading] = useState(false)
  
    const handleExportClick = async () => {
      setExportLoading(true)
      try {
        let payload = {
          downloadList: selectedKeys.map(item => item.title),
          status:status
        }
        if (exportType === 'xlsx') {
          try {
            const blob = await exportCandidate(
              params.roleId,
              instituteCampusId,
              exportType,
              payload
            )
            const url = window.URL.createObjectURL(new Blob([blob]))
            const link = document.createElement('a')
            link.href = url
            const statusTilte = downlaodData == 6 ? 'ELIGIBLE' : status
            if (categorayFilter == 'PLACEMENT') {
              link.setAttribute(
                'download',
                `${
                  jobRolePreviewData?.tittle +
                  '_' +
                  statusTilte +
                  '' +
                  (downlaodData === 1
                    ? '(UNRESTRICTED)'
                    : downlaodData === 6
                    ? '(RESTRICTED)'
                    : '') +
                  '_STUDENTS.xlsx'
                }`
              )
            } else {
              link.setAttribute(
                'download',
                `${jobRolePreviewData?.tittle + '_' + status + '_STUDENTS.xlsx'}`
              )
            }
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
  
            setExportLoading(false)
            handleTransferClick(false)
          } catch (error) {
            setExportLoading(false)
            ErrorMessage(error)
          } 
        } else if (exportType === 'googlesheet') {
          try {
            const response = await exportCandidate(
              params.roleId,
              instituteCampusId,
              exportType,
              payload
            )
            window.open(response?.data?.url, '_blank')
            setExportLoading(false)
            handleTransferClick(false)
          } catch (error) {
            setExportLoading(false)
            ErrorMessage(error)
          }
        } else {
          try {
            const blob = await exportCandidate(
              params.roleId,
              instituteCampusId,
              exportType,
              payload
            )
            const url = window.URL.createObjectURL(
              new Blob([blob], { type: 'text/csv' })
            )
            const link = document.createElement('a')
            const statusTilte = downlaodData == 6 ? 'ELIGIBLE' : status
            link.href = url
            link.setAttribute(
              'download',
              `${jobRolePreviewData?.tittle + '_' + status + '_STUDENTS.csv'}`
            )
            if (categorayFilter == 'PLACEMENT') {
              link.setAttribute(
                'download',
                `${
                  jobRolePreviewData?.tittle +
                  '_' +
                  statusTilte +
                  '' +
                  (downlaodData === 1
                    ? '(UNRESTRICTED)'
                    : downlaodData === 6
                    ? '(RESTRICTED)'
                    : '') +
                  '_STUDENTS.csv'
                }`
              )
            } else {
              link.setAttribute(
                'download',
                `${jobRolePreviewData?.tittle + '_' + status + '_STUDENTS.csv'}`
              )
            }
  
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            handleTransferClick(false)
  
            setExportLoading(false)
          } catch (error) {
            setExportLoading(false)
            ErrorMessage(error)
          }
        }
      } catch (error) {
        ErrorMessage(error)
      }
    }
  const data = [
    {
      eligible_students: 300,
      ineligible_students: 40,
      applied_students: 50,
      missed_students: 50,
      placed_students: 30,
    },
  ]

  const candidateCols = [
    {
      title: 'App. statuses - Colleges',
      dataIndex: 'instituteCampus',
      key: 'role',
      align: 'left',

      render: (instituteCampus, record) => {
        // Use the instituteCampus object from the API response
        const campusName = instituteCampus?.campusName || 'Unknown Campus';
        const campusLogoUrl = instituteCampus?.campusLogoUrl;
        
        // Determine status icon based on record.status
        const getStatusIcon = () => {
  const style = { marginTop: '8px' } 

  switch(record.status) {
    case -1:
      return <Tooltip title="Rejected"><div style={style}><PILReject size={19} /></div></Tooltip>;
    case 0:
      return <Tooltip title="Pending"><div style={style}><PILPending size={19} /></div></Tooltip>;
    case 1:
      return <Tooltip title="Accepted"><div style={style}><PILAccept size={19} /></div></Tooltip>;
    default:
      return <Tooltip title="Pending"><div style={style}><PILPending size={19} /></div></Tooltip>;
  }
};
        
        const CollegeItem = (
          <FlexWrap style={{ alignItems: 'flex-start', gap: '8px' }}>
            {getStatusIcon()}
            <AntdAvatar
              src={campusLogoUrl}
              size={35}
              IconName={campusName?.split('')[0]}
            />
            <RowNumberData>
              <Tooltip title={campusName}>
                {campusName?.length > 16
                  ? campusName?.substr(0, 16) + '...'
                  : campusName}
              </Tooltip>
            </RowNumberData>
          </FlexWrap>
        )
        return CollegeItem
      },
    },
    {
      title: ' POC ',
      dataIndex: 'POCDetails',

      key: 'company',
      align: 'left',

      render: (POCDetails, record) => {
        const primaryPoc = POCDetails && POCDetails.length > 0 
          ? POCDetails.find(poc => poc.isPrimary === true) || POCDetails[0]
          : null;
        return (
          <RowNumberData>
            <div
              style={{
                width: '140px',
              }}
            >
              <div>{primaryPoc?.name ?? ' -- '}</div>
              <Tooltip title={primaryPoc?.email}>
                <div
                  style={{
                    textWrap: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textTransform: 'initial',
                  }}
                >
                  {primaryPoc?.email ?? ''}
                </div>
              </Tooltip>
              <div>{primaryPoc?.number ?? ''}</div>
            </div>
          </RowNumberData>
        )
      },
    },
    {
      title: 'Studs. Applied',
      dataIndex: 'candidates',
      className: 'candidate-list-cell',
      key: 3,
      width: '135px',
      align: 'Center',
      render: (candidates, record) => {
        const candidateCount = typeof candidates === 'number' ? candidates : 0
        return (
          <EmptyDivElement
            className="candidate-list-count"
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {isLoadingState ? 0 : candidateCount}
          </EmptyDivElement>
        )
      },
    },{
      title: 'Studs. HIRED',
      dataIndex: 'candidateHiredCount',
      className: 'candidate-list-cell',
      key: 5,
      width: '135px',
      align: 'Center',
      render: (candidateHiredCount, record) => {
        const hiredCount = typeof candidateHiredCount === 'number' ? candidateHiredCount : 0
        return (
          <EmptyDivElement
            className="candidate-list-count"
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {isLoadingState ? 0 : hiredCount}
          </EmptyDivElement>
        )
      },
    },

  ]
  const handleTransferClick = async isOpen => {
    try {
      if (isOpen) {
        let fieldDatas = await getExportFiledData()
        if (jobRolePreviewData?.applicationFormTemplate) {
          fieldDatas = ['Form Responses', ...fieldDatas]
        }
        fieldDatas = fieldDatas.map((item, index) => {
          return {
            key: index,
            title: item,
          }
        })
        setData(fieldDatas)
      } else {
        setData([])
      }
      setSelectedKeys([])
      setExportType('')
      setTargetKeys([])
      setTransfer(isOpen)
    } catch (error) {}
  }
  return (
    <React.Fragment>
      <BorderContainer>
        {/* <div style={{
          display: 'flex',
          justifyContent: 'space-between', 
          justifyItems: 'center',
          alignItems: 'center',
          textAlign: 'center'
        }}>
         <ActionButton
            text={'Export'}
            color="secondary"
            marginBottom= {10}
            onClick={() => handleTransferClick(true)}
          />
          </div> */}
        <div ref={objectRef}></div>

        <FilterTotalCount>
          Showing{' '}
          {10 * state.candidateListPageNo + (
            Array.isArray(candidateList?.result) 
              ? candidateList?.result?.length 
              : Array.isArray(candidateList) 
                ? candidateList?.length 
                : 0
          )} of{' '}
          {candidateList?.count || (
            Array.isArray(candidateList?.result) 
              ? candidateList?.result?.length 
              : Array.isArray(candidateList) 
                ? candidateList?.length 
                : 0
          )}
        </FilterTotalCount>
        {/* <TableJobSearchFilter
          setSearchValue={value => handleSearch(value)}
          searchValue={state.candidateSearch || ''}
          hideFilter
          customTableHeight={'55px'}
        /> */}
        <StyledTablecount
          columns={candidateCols}
          dataSource={
            isLoadingState
              ? []
              : state?.candidateListLoading
              ? []
              : Array.isArray(candidateList?.result) 
                ? candidateList?.result 
                : Array.isArray(candidateList) 
                  ? candidateList 
                  : []
          }
          pagination={false}
          rowSelection={false}
          loading={state?.candidateListLoading}
          rowKey={record => record.id || record._id || record.uniRollNo || JSON.stringify(record)}
          expandable={
            state?.candidateStatus === 'RESTRICTED'
              ? {
                  expandedRowKeys: expandedRowKeys,
                  expandedRowRender: (record) => <RestrictionsPanel record={record} roleId={ params.roleId}/>,
                  expandIcon: () => null, // Hide the default plus icon
                  expandIconColumnIndex: -1, // Hide the expand icon column
                  onExpand: (expanded, record) => {
                    const recordKey = record.id || record._id || record.uniRollNo || JSON.stringify(record);
                    if (expanded) {
                      // Set only the currently expanded row
                      setExpandedRowKeys([recordKey]);
                    } else {
                      // Collapse the row
                      setExpandedRowKeys([]);
                    }
                  },
                }
              : undefined
          }
          
        />

        <ContainerAlignment>
          <Pagination
            totalPages={candidateList?.count || (
              Array.isArray(candidateList?.result) 
                ? candidateList?.result?.length 
                : Array.isArray(candidateList) 
                  ? candidateList?.length 
                  : 0
            )}
            pageSize={candidateList?.limit || 10}
            onChange={onPageChange}
            current={state.candidateListPageNo + 1}
          />
        </ContainerAlignment>
      </BorderContainer>

      {/* <PlacementHistoryWithResume
        studentId={studentId}
        isOpenHistory={isOpenHistory}
        setIsOpenHistory={setIsOpenHistory}
        getJobRolePreview={getJobRolePreview}
        getStudentPlacedList={getStudentPlacedList}
        getPlacementHistoryList={getPlacementHistoryList}
        getPreview={getPreview}
        roleID={params?.roleId}
      /> */}
      <ExportTransfer
        open={transfer}
        handleClose={handleTransferClick}
        data={exportData}
        columns={exportColumns}
        disabled={disabled}
        setDisabled={setDisabled}
        targetKeys={targetKeys}
        setTargetKeys={setTargetKeys}
        setSelectedKeys={setSelectedKeys}
        exportType={exportType}
        handleExportType={handleExportType}
        handleExportClick={handleExportClick}
        exportLoading={exportLoading}
        setExportLoading={setExportLoading}
      />
    </React.Fragment>
  )
}
